module.exports = __webpack_public_path__ + "static/media/brook-landing-immensity-of-template-bg.dd8311af.jpg";